// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyB-oV3I_S4114gtFmIA550txlAU7YnD9NI",
  authDomain: "scilib-70ab1.firebaseapp.com",
  projectId: "scilib-70ab1",
  storageBucket: "scilib-70ab1.appspot.com",
  messagingSenderId: "1057681901283",
  appId: "1:1057681901283:web:a6908b6fe8a444339127d6"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

export default app;